export default __webpack_public_path__ + "static/media/colors_loading_btn.df1e3eaf.gif";